import React from 'react';
import { ReportEntityType } from 'components/ReportsModule/types';
import useReportQueryParams from '../../hooks/use-report-query-params';
import ReportHeader from '../common/ReportHeader';
import PrmDistrictReport from './District';
import PrmClassroomReport from './Classroom';
import PrmOrganizationReport from './Organization';
import PrmStudentReport from './Student';

const ENTITY_MAP: { [key in ReportEntityType]?: any } = {
  [ReportEntityType.DISTRICT]: PrmDistrictReport,
  [ReportEntityType.CLASSROOM]: PrmClassroomReport,
  [ReportEntityType.SCHOOL]: PrmOrganizationReport,
  [ReportEntityType.USER]: PrmOrganizationReport,
  [ReportEntityType.USER_GROUP]: PrmOrganizationReport,
  [ReportEntityType.STUDENT]: PrmStudentReport
};

const PrmReport: React.FC = () => {
  const [{ entityType, entityId }] = useReportQueryParams();
  const EntityReport = ENTITY_MAP[entityType];

  if (!entityId) return null;

  if (!EntityReport) return null;

  return (
    <>
      <ReportHeader />
      <EntityReport />
    </>
  );
};

export default PrmReport;
